// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__Jrbkw","blink":"style_blink__dVOHK"};